module.exports = __webpack_public_path__ + "media/images/home/expand-5ecc4167e392c5f62e326840485e5518.svg";